import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=fce13a26&"
import script from "./XSelect.vue?vue&type=script&lang=ts&"
export * from "./XSelect.vue?vue&type=script&lang=ts&"
import style0 from "./XSelect.vue?vue&type=style&index=0&id=fce13a26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports